export default __webpack_public_path__ + "static/17-79d058f7eecee54f8b950d44162997a7.jpg";